import { render } from "./ChildDevelopmentProgress.vue?vue&type=template&id=62715a88&ts=true"
import script from "./ChildDevelopmentProgress.vue?vue&type=script&lang=ts"
export * from "./ChildDevelopmentProgress.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__